import { makeStyles } from "@material-ui/core";

const orientationMap = {
  horizontal: "row",
  vertical: "column",
};

const useStyles = makeStyles(() => ({
  root: (props) => ({
    display: props.align ? "flex" : undefined,
    flexDirection: orientationMap[props.orientation],
    justifyContent: props.align,
    "& > button": {
      marginLeft:
        props.gap && props?.orientation !== "vertical"
          ? `${props.gap}px !important`
          : undefined,
      marginTop:
        props.gap && props?.orientation === "vertical"
          ? `${props.gap}px !important`
          : undefined,
      borderRight: props.gap ? "0 !important" : undefined,
      borderRadius: props.gap ? "4px !important" : undefined,
      "&:first-child": {
        marginTop: "0 !important",
        marginLeft: "0 !important",
      },
    },
  }),
}));

export default useStyles;
